// @flow

import * as React from 'react';

import Box from 'sail/Box';
import Group from 'sail/Group';
import {Subheading, Text} from 'sail/Text';
import {DocsIcon, Link} from 'docs/components';
import type {VideoModelWithTopic, VideoResourceModel} from 'docs/data';
import {ShareFeedback} from './Feedback';

type VideoInfoProps = {|
  video: VideoModelWithTopic,
  currentTime: number,
|};

const RelatedResources = ({
  resources,
}: {
  resources: Array<VideoResourceModel>,
}) => {
  if (resources.length === 0) {
    return null;
  }

  return (
    <Box className="PlaylistPlayer-RelatedResources">
      <Subheading color="gray400">Related resources</Subheading>
      {resources.map((resource) => {
        const icon = resource.url.includes('github') ? (
          <DocsIcon category="general" icon="github" size={16} />
        ) : (
          <DocsIcon category="general" icon="guide" color="blue" size={16} />
        );
        return (
          <Group
            direction="horizontal"
            alignItems="center"
            padding={{top: 12}}
            spacing={8}
            key={resource.url}
          >
            {icon}
            <Link href={resource.url}>{resource.title}</Link>
          </Group>
        );
      })}
    </Box>
  );
};

export const VideoInfo = ({video, currentTime}: VideoInfoProps) => {
  const presenter = video.presenters ? video.presenters[0] : null;
  const resources = [...(video.relatedDocs || []), ...(video.resources || [])];

  return (
    <Box className="PlaylistPlayer-VideoInfo" margin={{top: 24, bottom: 24}}>
      <Box
        className="PlaylistPlayer-row-container"
        flex={{justifyContent: 'space-between'}}
      >
        <Box className="PlaylistPlayer-left-container" margin={{right: 32}}>
          <Box>
            <Text weight="bold" size={24} lineHeight={36}>
              {video.title}
            </Text>
          </Box>
          {presenter && (
            <Box>
              <Text color="gray">
                Featuring {presenter.name}, {presenter.title}
              </Text>
            </Box>
          )}
          <Box margin={{top: 16}}>
            <Text size={16} lineHeight={24}>
              {video.description}
            </Text>
          </Box>
          <Box margin={{top: 32}}>
            <ShareFeedback videoID={video.id} />
          </Box>
        </Box>
        <Box className="PlaylistPlayer-right-container">
          <RelatedResources resources={resources} />
        </Box>
      </Box>
    </Box>
  );
};
